'use client';

import { faWandMagicSparkles } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { PulseButton } from 'src/components';
import { useLogging } from 'src/context/logging';
import { useRouter } from 'next/navigation';

const StrategyBuilderButton = () => {
  const router = useRouter();
  const log = useLogging();

  const handleStrategyBuilder = () => {
    log.event('Strategy builder button clicked', {
      source: 'TargetStrategiesGrid',
    });
    router.push('/settings/admin/strategy-manager/strategy-builder');
  };
  return (
    <PulseButton
      variant="outline"
      color="primary"
      size="sm"
      startDecorator={faWandMagicSparkles}
      onClick={handleStrategyBuilder}
      data-testid="strategy-builder-button"
      aria-label="Open strategy builder wizard"
    >
      Strategy Builder
    </PulseButton>
  );
};

export default StrategyBuilderButton;
